"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveLogins = void 0;
var tslib_1 = require("tslib");
/**
 * @internal
 */
function resolveLogins(logins) {
    return Promise.all(Object.keys(logins).reduce(function (arr, name) {
        var tokenOrProvider = logins[name];
        if (typeof tokenOrProvider === "string") {
            arr.push([name, tokenOrProvider]);
        }
        else {
            arr.push(tokenOrProvider().then(function (token) { return [name, token]; }));
        }
        return arr;
    }, [])).then(function (resolvedPairs) {
        return resolvedPairs.reduce(function (logins, _a) {
            var _b = tslib_1.__read(_a, 2), key = _b[0], value = _b[1];
            logins[key] = value;
            return logins;
        }, {});
    });
}
exports.resolveLogins = resolveLogins;
//# sourceMappingURL=resolveLogins.js.map